module.exports = __webpack_public_path__ + "img/za.67ff2e10.svg";